import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import ShopRecommendationsWithLink from './ShopRecommendations';

export const getShopRecommendationsWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: ShopRecommendationsWithLink,
});
